// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2V22H2V2H22ZM18 11V8H16V11H18ZM13 13V10H11V13H13ZM8 18V12H6V18H8ZM18 18V13H16V18H18ZM13 18V15H11V18H13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-analytics-filled')
export default class AnalyticsFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'analytics-filled',
    }
  }
}
